var config = require('../../variants/' + BUILD_VARIANT + '/config.js').default;

const API_URL = config.app.endpoint + "mobile/";

export default {
  corona() {
    return this.send('coronavirus', {
    });
  },
  login(username, password) {
    return this.send("login", {
      username: username,
      password: password
    });
  },
  freeLogin(cellphone, name) {
    return this.send("freeLogin", {
      cellphone: cellphone,
      name: name
    });
  },
  imageUrl(image) {
    return config.app.endpoint + image;
  },
  endChat(chatid) {
    return this.send('endChat', {
      chat_id: chatid
    });
  },
  acceptTerms(userId) {
    return this.send('acceptTerms', {
      user_id: userId
    });
  },
  sendChatImage(cellphone, userId, chatId, image) {
    return this.send('saveChatImage', {
      cell_no: cellphone,
      user_id: userId,
      chat_logs_chat_id: chatId,
      chat_logs_text: '',
      chat_date: moment().format('YYYY-MM-dd HH:mm:ss'),
      chatImage: image
    });
  },
  register(id_number,
           name,
           sname,
           cell,
           password,
           home_address_1,
           home_address_2,
           home_suburb,
           home_province,
           home_postal_code,
           dependents,
           ice1,
           ice2,
           age,
           sex,
           race,
           language,
           pregnant,
           weight,
           height,
           smoker,
           drink,
           blood_type,
           illness,
           allergies) {
    return this.send('registerUser', {
      id_number: id_number,
      name: name,
      sname: sname,
      cell: cell,
      password: password,
      home_address_1: home_address_1,
      home_address_2: home_address_2,
      home_suburb: home_suburb,
      home_province: home_province,
      home_postal_code: home_postal_code,
      dependents: dependents,
      ice1: ice1,
      ice2: ice2,
      age: age,
      sex: sex,
      race: race,
      language: language,
      pregnant: pregnant,
      weight: weight,
      height: height,
      smoker: smoker,
      drink: drink,
      blood_type: blood_type,
      illness: illness,
      allergies: allergies
    });
  },
  sendChatAudio(cellphone, userId, chatId, audio) {
    return this.send('saveChatAudio', {
      cell_no: cellphone,
      user_id: userId,
      chat_logs_chat_id: chatId,
      chat_logs_text: '',
      chat_date: moment().format('YYYY-MM-dd HH:mm:ss'),
      chatImage: audio
    });
  },
  rateChat(cellphone, userId, chatId, rating) {
    return this.send('chatRating', {
      cell_no: cellphone,
      user_id: userId,
      chat_id: chatId,
      rating: rating
    });
  },
  requestPassword(cellphone) {
    return this.send('forgotPassword.php', {
      mobile: cellphone
    });
  },
  requestCallback(cellphone, userId, chatId) {
    console.log({
      cell_no: cellphone,
      user_id: userId,
      chat_id: chatId
    });

    return this.send('callback', {
      cell_no: cellphone,
      user_id: userId,
      chat_id: chatId
    });
  },
  loadTips(cellphone, userid) {
    return this.send('medicalTips', {
      cell_no: cellphone,
      userid: userid
    });
  },
  getInbox(cellphone, userid) {
    return this.send('inbox', {
      cell_no: cellphone,
      user_id: userid
    });
  },
  documentRequest(cellphone, userid, documents) {
    return this.send('documents', {
      cell_no: cellphone,
      user_id: userid,
      ...documents
    });
  },
  send(url, params) {
    var url = API_URL + url;
    console.log("API: " + url);

    console.log(params);

    var data = new FormData();

    for (var i in params) {
      data.set(i, params[i]);
    }

    const myInit = {
      method: 'POST',
      body: data,
      headers: {}
    };

    const myRequest = new Request(url, myInit);

    return fetch(myRequest).then(function (response) {
      var json = response.json();

      return json;
    }).catch(function (error) {
      console.log(error);
    });
  },
  saveGcmKey(userid, cell, token) {
    return this.send('gcmUpdate', {
      cell_no: cell,
      user_id: userid,
      reg_id: token
    });
  },
  getGenders() {
    return [
      'Male',
      'Female'
    ]
  },
  emergency(userid, cell, latitude, longitude) {
    return this.send('emergency', {
      user_id: userid,
      cell: cell,
      cell_no: cell,
      latitude: latitude,
      longitude: longitude
    });
  },
  getLanguages() {
    return [
      {id: 3, label: 'Afrikaans'},
      {id: 4, label: 'English'},
      {id: 7, label: 'Sotho'},
      {id: 6, label: 'Tswana'},
      {id: 2, label: 'Xhosa'},
      {id: 1, label: 'Zulu'}
    ]
  },
  createChat(userid, cell, chatId) {
    return this.send('chat', {
      chat_type: 'nurse',
      user_id: userid,
      cell_no: cell,
      reuse: 'true',
      chat_id: chatId
    });
  },
  sendChatMessage(cell_no, user_id, chat_id, text) {
    return this.send('saveChat', {
      cell_no: cell_no,
      user_id: user_id,
      chat_logs_chat_id: chat_id,
      chat_logs_text: text
    });
  },
  fetchMessages(cell_no, user_id, chat_id, since) {
    return this.send('chatMessage', {
      cell_no: cell_no,
      user_id: user_id,
      chat_id: chat_id,
      since: since
    })
  },
  updateInfo(cell_no, userid, age, sex, race, pregnant, weight, height, smoker, drink, blood_type, illness, allergies,
             home_address_1, home_address_2, home_suburb, home_province, home_postal_code, dependants, ice1, ice2,
             name, surname, language_id, password) {

    return this.send('updateUserInfo', {
      cell_no: cell_no,
      user_id: userid,
      age: age,
      sex: sex,
      race: race,
      pregnant: pregnant,
      weight: weight,
      height: height,
      smoker: smoker,
      drink: drink,
      blood_type: blood_type,
      illness: illness,
      allergies: allergies,
      home_address_1: home_address_1,
      home_address_2: home_address_2,
      home_suburb: home_suburb,
      home_province: home_province,
      home_postal_code: home_postal_code,
      dependents: dependants,
      ice1: ice1,
      ice2: ice2,
      name: name,
      surname: surname,
      language_id: language_id,
      password: password
    });
  },
  getBloodGroups() {
    return [
      'Not Sure',
      'A Positive (A+)',
      'A Negative (A-)',
      'B Positive (B+)',
      'B Negative (B-)',
      'O Positive (O+)',
      'O Negative (O-)',
      'AB Positive (AB+)',
      'AB Negative (AB-)'
    ]
  }
}
